import { useState } from "react";
import { useTranslation } from "next-i18next";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import { cn } from "../../../../../lib/utils";
import { useProducts } from "../../hooks/useProducts";

const ASSETS_PATH = "/landings/assets/images/products/hub-talentos";

const SLIDES_CONFIG = [
	{ key: "testesQualidade", image: `${ASSETS_PATH}/diferenciais-testes-qualidade.png` },
	{ key: "desenvolvimento", image: `${ASSETS_PATH}/diferenciais-desenvolvimento.png` },
	{ key: "documentacao", image: `${ASSETS_PATH}/diferenciais-documentacao.png` },
	{ key: "planejamentoTecnico", image: `${ASSETS_PATH}/diferenciais-planejamento-tecnico.png` },
];

export default function DiferenciaisSection() {
	const { scrollToContactForm } = useProducts();
	const { t } = useTranslation();
	const [activeSlide, setActiveSlide] = useState(0);

	const slides = SLIDES_CONFIG.map(({ key, image }) => ({
		label: t(`products.hub-talentos.diferenciais.slides.${key}`),
		image,
	}));

	return (
		<section>
			<div className="container-blog">
			<div
				className={cn(
					"flex flex-col gap-8 mx-auto",
					"tablet:flex-row tablet:items-center tablet:gap-4",
					"laptop:gap-10 laptop:max-w-[1041px] laptop:justify-center",
				)}
			>
				{/* Text */}
				<div className="max-w-full text-center tablet:text-left tablet:flex-1 tablet:min-w-0 laptopM:max-w-[697px]">
					<h2
						className={cn(
							"text-vivid-02 m-0",
							"text-[24px] leading-[32px]",
							"tablet:text-[24px] tablet:leading-[32px]",
							"laptop:text-[40px] laptop:leading-[48px]",
							"tablet:max-w-[440px] mx-auto tablet:mx-0",
						)}
					>
						<span className="font-normal !text-vivid-02">
							{t("products.hub-talentos.diferenciais.title")}
						</span>
						<br />
						<span className="font-semibold !text-vivid-02">
							{t("products.hub-talentos.diferenciais.titleHighlight")}
						</span>
					</h2>

					<p
						className={cn(
							"text-white mb-0 ml-0 mr-0 mt-[16px]",
							"text-base leading-7",
							"tablet:text-sm tablet:leading-[22px]",
							"laptop:text-xl laptop:leading-8",
						)}
					>
						{t("products.hub-talentos.diferenciais.description")}
					</p>
					<p
						className={cn(
							"mb-0 ml-0 mr-0 mt-[20px]",
							"text-base leading-7",
							"tablet:text-sm tablet:leading-[22px]",
							"laptop:text-xl laptop:leading-8",
						)}
					>
						<span className="!text-white">
							{t("products.hub-talentos.diferenciais.descriptionPrefix")}
						</span>
						<br className="tablet:hidden" />
						<span className="font-bold !text-ds-brand-green-300">
							{" "}
							{t("products.hub-talentos.diferenciais.descriptionHighlight")}
						</span>
					</p>
				</div>

				{/* Illustration carousel */}
				<div
					className={cn(
						"flex flex-col items-center shrink-0",
						"w-[208px] mx-auto",
						"tablet:w-[208px] tablet:mx-0",
						"laptop:w-[304px]",
					)}
				>
					<Swiper
						modules={[Autoplay, Pagination]}
						autoplay={{ delay: 4000, disableOnInteraction: false }}
						pagination={false}
						loop
						onSlideChange={(swiper) => setActiveSlide(swiper.realIndex)}
						className="w-[160px] h-[160px] tablet:w-[160px] tablet:h-[160px] laptop:w-[248px] laptop:h-[248px] rounded-lg"
					>
						{slides.map((slide, i) => (
							<SwiperSlide key={i}>
								<img
									src={slide.image}
									alt={slide.label}
									className="w-full h-full object-cover"
								/>
							</SwiperSlide>
						))}
					</Swiper>

					<span className="-mt-2 z-10 bg-ds-brand-green-500 !text-[#333] text-xs tablet:text-xs laptop:text-base font-semibold uppercase px-2 tablet:px-2 laptop:px-4 py-1 laptop:py-2 rounded-full h-6 tablet:h-6 laptop:h-8 flex items-center justify-center whitespace-nowrap">
						{slides[activeSlide].label}
					</span>

					<div className="flex items-center gap-2 mt-6">
						{slides.map((_, i) => (
							<div
								key={i}
								className={cn(
									"rounded-full transition-all duration-300",
									i === activeSlide
										? "w-4 h-2 bg-vivid-02"
										: "w-2 h-2 bg-neutral-05",
								)}
							/>
						))}
					</div>
				</div>
			</div>

			{/* CTA */}
			<div className="flex justify-center mt-8 tablet:mt-8 laptop:mt-10">
				<button
					onClick={scrollToContactForm}
					className="bg-vivid-02 h-[40px] tablet:h-[40px] laptop:h-[64px] rounded-full px-6 tablet:px-6 laptop:px-12 flex items-center justify-center cursor-pointer border-0 hover:opacity-90 transition-opacity"
				>
					<span className="!text-ds-brand-green-1000 text-sm tablet:text-sm laptop:text-xl font-bold uppercase tracking-[1.2px] whitespace-nowrap leading-[24px] laptop:leading-[40px]">
						{t("products.hub-talentos.diferenciais.ctaButton")}
					</span>
				</button>
			</div>
			</div>
		</section>
	);
}
